import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  joinToString1cxrrlmo0chqs as joinToString,
  plus310ted5e4i90h as plus,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import {
  takeWhile17zwcj046i086 as takeWhile,
  take2rh6pen3z50h7 as take,
  toListx6x8nvfmvvht as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  ChildAttendance80k6ssgtlom9 as ChildAttendance,
  ID1z61wlmtvxrjn as ID,
  ID14pksykyak8vt as ID_0,
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  ID3dyn3t5exl4nz as ID_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_location22dxferxpyzkz as get_location,
  get_date4gxx2ixf9cue as get_date,
  get_location2f1azencio7x2 as get_location_0,
  get_submitted382abp2i1n972 as get_submitted,
  get_approved221jlb71nbap0 as get_approved,
  get_attendance2q4781hmwhput as get_attendance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { insideoec66sredh4u as inside } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dateRangeConditions.mjs';
import { and3dbt2f202um49 as and } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
  ID3lnbkn76l7dgd as ID_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  weight31wqab1913ly4 as weight,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance } from '../../theme/semantics.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  None_instance1vdtnxdfytk8h as None_instance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowWrapping1cfo2cqk4jxme as RowWrapping,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Align_Stretch_getInstance2huaa6rbagugp as Align_Stretch_getInstance,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_lockedtaws15usdfi7 as get_locked } from '../../icons.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  Fixedsogarmaf088q as Fixed,
  TableColumn199vk8dy8jaqx as TableColumn,
  tableWithSticky1958em9ua7p76 as tableWithSticky,
} from '../components/table.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { ChildPlacementDetailPagewfmc55i6s15v as ChildPlacementDetailPage } from '../children/ChildPlacementDetailPage.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  AttendanceTableCell_getInstance1kwc03bvz0h68 as AttendanceTableCell_getInstance,
  get_entries1r7oopv3kkcq7 as get_entries,
  AttendanceEntryBox2fe5zhsdvgxaf as AttendanceEntryBox,
  AttendanceCellState_NeedsEntry_getInstance1nr9dxyvhbguy as AttendanceCellState_NeedsEntry_getInstance,
  AttendanceCellState_Closure_getInstanced8orc2c03u9w as AttendanceCellState_Closure_getInstance,
  AttendanceCellState_NotScheduled_getInstance3itq8wmesmvbz as AttendanceCellState_NotScheduled_getInstance,
  AttendanceCellState_NotPlaced_getInstancedryb5nvy8nlp as AttendanceCellState_NotPlaced_getInstance,
  Companion_instance3avuh2je008a9 as Companion_instance,
} from '../components/attendanceStyling.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  ActualAttendance3tb4czhk5mikp as ActualAttendance,
  Companion_getInstance1ts49hpe5lvz6 as Companion_getInstance_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import {
  today1rno4frfjp5oe as today,
  nowLocal2mdv5rmil2cf2 as nowLocal,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  format2n4cpzximuj7a as format,
  plus1et5dysousgt9 as plus_0,
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance_2,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox } from '../components/view-utilities.mjs';
import { Companion_getInstance2lv012sehjn6z as Companion_getInstance_3 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/LocalDateFormat.mjs';
import { Companion_getInstance3rwcbkvzrbmti as Companion_getInstance_4 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/YearMonthFormat.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { char1r4ssccmdfesy as char } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormatBuilder.mjs';
import { Padding_NONE_getInstance3hrh9czbcdldi as Padding_NONE_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormat.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance_5 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimeUnit.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { RecordedAction2zjpqvlfzzos as RecordedAction } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { confirmationDialoginprr3lfvaqc as confirmationDialog } from '../components/dialogs.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { closePopoversckn4u815mr3s as closePopovers } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var headerHeight;
var rowHeight;
var dayColumnWidth;
function get_weekdayFormat() {
  _init_properties_attendanceGrid_kt__smmydr();
  return weekdayFormat;
}
var weekdayFormat;
function get_menuDateFormat() {
  _init_properties_attendanceGrid_kt__smmydr();
  return menuDateFormat;
}
var menuDateFormat;
function attendanceGrid(_this__u8e3s4, period, closures, placements) {
  _init_properties_attendanceGrid_kt__smmydr();
  var today = remember(VOID, VOID, VOID, VOID, attendanceGrid$lambda);
  var rows = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(placements);
    var tmp_0 = attendanceGrid$lambda$lambda;
    return sortedWith(tmp, compareBy([tmp_0, attendanceGrid$lambda$lambda_0]));
  });
  var days = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var range = $this$remember.invoke_r7m7el_k$(period).period_1;
    var tmp = generateSequence(range.start_1, attendanceGrid$lambda$lambda_1);
    return toList(take(takeWhile(tmp, (it) => it.compareTo_e7gwgq_k$(range.endInclusive_1) <= 0), 101));
  });
  var periodTooLong = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(days).get_size_woubt6_k$() > 100);
  var allAttendances = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenAttendance_3o0zzj_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(ChildAttendance()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp$ret$0 = and(eq(get_location(it), new (ID())($this$remember.invoke_r7m7el_k$(period).location_1)), inside(get_date(it), $this$remember.invoke_r7m7el_k$(period).period_1));
    return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp$ret$0, VOID, VOID, 10000)));
  });
  var programs = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
    var tmp$ret$7 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$7);
    var tmp$ret$5 = eq(get_location_0(it), new (ID())($this$remember.invoke_r7m7el_k$(period).location_1));
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp$ret$5)));
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$12 = new (ID_2())(element._id_1);
      destination.put_4fpzoq_k$(tmp$ret$12, element);
    }
    return destination;
  });
  var needsEntryCount = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = $this$remember.invoke_r7m7el_k$(placements).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp = sum;
      var tmp0 = $this$remember.invoke_r7m7el_k$(days);
      var tmp$ret$15;
      $l$block: {
        // Inline function 'kotlin.collections.count' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.isEmpty_y1axqb_k$();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$15 = 0;
          break $l$block;
        }
        var count = 0;
        var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp_1;
          if (!(expectedFor(element, element_0, $this$remember.invoke_r7m7el_k$(closures), $this$remember.invoke_r7m7el_k$(programs)) == null)) {
            var tmp0_0 = $this$remember.invoke_r7m7el_k$(allAttendances);
            var tmp$ret$17;
            $l$block_1: {
              // Inline function 'kotlin.collections.none' call
              var tmp_2;
              if (isInterface(tmp0_0, Collection())) {
                tmp_2 = tmp0_0.isEmpty_y1axqb_k$();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$17 = true;
                break $l$block_1;
              }
              var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
                var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
                if (equals(element_1.placement_1, element._id_1) && element_1.date_1.equals(element_0)) {
                  tmp$ret$17 = false;
                  break $l$block_1;
                }
              }
              tmp$ret$17 = true;
            }
            tmp_1 = tmp$ret$17;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            count = count + 1 | 0;
            checkCountOverflow(count);
          }
        }
        tmp$ret$15 = count;
      }
      sum = tmp + tmp$ret$15 | 0;
    }
    return sum;
  });
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  var this_0 = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(today).compareTo_e7gwgq_k$($this$shownWhen.invoke_r7m7el_k$(period).period_1.endInclusive_1) > 0 && $this$shownWhen.invoke_r7m7el_k$(period).submitted_1 == null);
  // Inline function 'com.lightningkite.kiteui.views.warning' call
  var this_1 = themed(this_0, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_2 = themed(this_1, WarningSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_2.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_3 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_4 = weight(this_3, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_4.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).attendanceNeedsEntryMessage_grklld_k$($this$invoke.invoke_r7m7el_k$(needsEntryCount)));
  element_0.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_5 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_6 = themed(this_5, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Button())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_6.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Button$_get_enabled_$ref_61t7nx(element_1);
  var tmp_4 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(needsEntryCount) === 0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_1.willAddChild_hz2iwc_k$(element_2);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, attendanceGrid$lambda_0);
  element_2.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_2);
  element_1.set_action_2ds022_k$(Action('Submit attendance', VOID, VOID, VOID, VOID, VOID, attendanceGrid$slambda(element_1, period)));
  element_1.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  var this_7 = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) && !($this$shownWhen.invoke_r7m7el_k$(period).submitted_1 == null));
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_8 = themed(this_7, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_9 = themed(this_8, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (RowOrCol())(this_9.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_9.willAddChild_hz2iwc_k$(element_3);
  element_3.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.compact' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_10 = themed(element_3, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_10.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_10.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (RowOrCol())(element_4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_4.willAddChild_hz2iwc_k$(element_5);
  element_5.set_vertical_nuap32_k$(false);
  var tmp0 = get_centered(element_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var icon = get_locked(Companion_getInstance()).resize_q1xpz0_k$(get_rem(1.25));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (IconView())(tmp0.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  tmp0.willAddChild_hz2iwc_k$(element_6);
  element_6.set_source_3o5lkf_k$(icon);
  element_6.set_description_s1386w_k$('Locked');
  element_6.onStartup_vrxh3i_k$();
  tmp0.addChild_2qpft2_k$(element_6);
  text(get_bold(get_centered(element_5)), 'Locked');
  element_5.onStartup_vrxh3i_k$();
  element_4.addChild_2qpft2_k$(element_5);
  text(element_4, 'This period has been submitted and is blocked from further edits. If a correction is needed, contact TCG.');
  element_4.onStartup_vrxh3i_k$();
  this_10.addChild_2qpft2_k$(element_4);
  element_3.onStartup_vrxh3i_k$();
  this_9.addChild_2qpft2_k$(element_3);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  var this_11 = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(period).submitted_1 == null) && $this$shownWhen.invoke_r7m7el_k$(period).approved_1 == null);
  // Inline function 'com.lightningkite.kiteui.views.warning' call
  var this_12 = themed(this_11, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_13 = themed(this_12, WarningSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = new (RowOrCol())(this_13.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  this_13.willAddChild_hz2iwc_k$(element_7);
  element_7.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_14 = get_centered(element_7);
  var tmp$ret$62 = weight(this_14, 1.0);
  text(tmp$ret$62, 'This attendance period is awaiting approval by TCG.');
  var tmp_8 = get_centered(element_7);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_15 = shownWhen(tmp_8, VOID, VOID, attendanceGrid$lambda_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_16 = themed(this_15, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = new (Button())(this_16.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  this_16.willAddChild_hz2iwc_k$(element_8);
  text(element_8, 'Approve attendance');
  element_8.set_action_2ds022_k$(Action('Approve attendance', VOID, VOID, VOID, VOID, VOID, attendanceGrid$slambda_0(period)));
  element_8.onStartup_vrxh3i_k$();
  this_16.addChild_2qpft2_k$(element_8);
  element_7.onStartup_vrxh3i_k$();
  this_13.addChild_2qpft2_k$(element_7);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  var this_17 = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(period).approved_1 == null));
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_18 = themed(this_17, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_19 = themed(this_18, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (RowOrCol())(this_19.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  this_19.willAddChild_hz2iwc_k$(element_9);
  element_9.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_20 = get_centered(element_9);
  var tmp$ret$73 = weight(this_20, 1.0);
  text(tmp$ret$73, 'Attendance period has been approved.');
  element_9.onStartup_vrxh3i_k$();
  this_19.addChild_2qpft2_k$(element_9);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  var this_21 = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(today).compareTo_e7gwgq_k$($this$shownWhen.invoke_r7m7el_k$(period).period_1.start_1) < 0);
  // Inline function 'com.lightningkite.kiteui.views.warning' call
  var this_22 = themed(this_21, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_23 = themed(this_22, WarningSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = new (RowOrCol())(this_23.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  this_23.willAddChild_hz2iwc_k$(element_10);
  element_10.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  element_10.willAddChild_hz2iwc_k$(element_11);
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_11);
  var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_11));
  element_11.invoke_bnq13k_k$(tmp_11, attendanceGrid$lambda_2);
  element_11.onStartup_vrxh3i_k$();
  element_10.addChild_2qpft2_k$(element_11);
  element_10.onStartup_vrxh3i_k$();
  this_23.addChild_2qpft2_k$(element_10);
  var tmp_12 = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(today).compareTo_e7gwgq_k$($this$shownWhen.invoke_r7m7el_k$(period).period_1.start_1) >= 0);
  var tmp_13 = attendanceGrid$lambda_3;
  var tmp_14 = get_rem_0(4);
  var tmp_15 = attendanceGrid$lambda_4;
  var tmp_16 = new (Fixed())(get_rem_0(10));
  var tmp_17 = _Constant___init__impl__v45mub(listOf(new (TableColumn())(tmp_15, tmp_16, VOID, VOID, VOID, ($this$TableColumn, placement) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Link())($this$TableColumn.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$TableColumn.willAddChild_hz2iwc_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    element_0.set_gap_jwjroq_k$(get_rem(0.0));
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_0 = get_bold(element_0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_0.willAddChild_hz2iwc_k$(element_1);
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(placement).childName_1);
    element_1.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element_0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
    element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = $this$invoke.invoke_r7m7el_k$(placement).schedule_1.get_programs_mo5naw_k$();
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        var it = element.raw_1;
        var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(programs).get_wei43m_k$(new (ID_2())(it));
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.add_utx5q5_k$(tmp0_safe_receiver);
        }
      }
      var tmp = destination;
      return joinToString(tmp, ', ', VOID, VOID, VOID, VOID, attendanceGrid$lambda$lambda$lambda);
    });
    element_2.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_2);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = Link$_get_to_$ref_jq7esp(element);
    var tmp_7 = getPropertyCallableRef('to', 0, tmp_5, tmp_6, Link$_set_to_$ref_i9gu5x(element));
    element.invoke_bnq13k_k$(tmp_7, ($this$invoke) => () => new (ChildPlacementDetailPage())($this$invoke.invoke_r7m7el_k$(placement)._id_1));
    element.onStartup_vrxh3i_k$();
    $this$TableColumn.addChild_2qpft2_k$(element);
    return Unit_instance;
  })));
  tableWithSticky(tmp_12, rows, tmp_13, tmp_14, new (Constant())(tmp_17), remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = attendanceGrid$lambda$lambda_2;
    var tmp_0 = new (Fixed())(get_rem_0(6));
    var tmp_1 = listOf(new (TableColumn())(tmp, tmp_0, VOID, VOID, VOID, ($this$TableColumn, placement) => {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      // Inline function 'com.lightningkite.kiteui.views.compact' call
      var this_0 = themed($this$TableColumn, CardSemantic_getInstance());
      var tmp$ret$106 = themed(this_0, CompactSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_1 = themed(tmp$ret$106, SubtextSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (Button())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_1.willAddChild_hz2iwc_k$(element);
      text(get_centered(element), 'As scheduled');
      element.set_action_2ds022_k$(Action('Fill As Scheduled', VOID, VOID, VOID, VOID, VOID, attendanceGrid$lambda$lambda$slambda($this$remember, placement, days, today, closures, programs, allAttendances, element)));
      element.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element);
      return Unit_instance;
    }));
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.invoke_r7m7el_k$(days);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp_2 = attendanceGrid$lambda$lambda_3(item);
      var tmp_3 = new (Fixed())(get_rem_0(4));
      var tmp_4 = Align_Stretch_getInstance();
      var tmp_5 = Align_Center_getInstance();
      var tmp$ret$112 = new (TableColumn())(tmp_2, tmp_3, tmp_4, VOID, tmp_5, attendanceGrid$lambda$lambda_4(item, closures, programs, $this$remember, period, allAttendances));
      destination.add_utx5q5_k$(tmp$ret$112);
    }
    return plus(tmp_1, destination);
  }));
  // Inline function 'com.lightningkite.kiteui.views.direct.rowWrapping' call
  var this_24 = themed(_this__u8e3s4, AttendanceTableCell_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_12 = new (RowWrapping())(this_24.get_context_h02k06_k$());
  ensureOutermostElement(element_12);
  this_24.willAddChild_hz2iwc_k$(element_12);
  var _iterator__ex2g4s = get_entries().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var state = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'com.lightningkite.kiteui.views.compact' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_25 = themed(element_12, CompactSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_13 = new (RowOrCol())(this_25.get_context_h02k06_k$());
    ensureOutermostElement(element_13);
    this_25.willAddChild_hz2iwc_k$(element_13);
    element_13.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    var this_26 = themed(sizeConstraints(element_13, VOID, VOID, VOID, VOID, VOID, get_rem_0(1), get_rem_0(1)), new (AttendanceEntryBox())(state));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_14 = new (Frame())(this_26.get_context_h02k06_k$());
    ensureOutermostElement(element_14);
    this_26.willAddChild_hz2iwc_k$(element_14);
    text(get_centered(element_14), state.mark_1);
    element_14.onStartup_vrxh3i_k$();
    this_26.addChild_2qpft2_k$(element_14);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_15 = new (TextView())(element_13.get_context_h02k06_k$());
    ensureOutermostElement(element_15);
    element_13.willAddChild_hz2iwc_k$(element_15);
    element_15.set_themeChoice_py59um_k$(element_15.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_18 = KMutableProperty0();
    var tmp_19 = TextView$_get_content_$ref_4pzcwl(element_15);
    var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb(element_15));
    element_15.invoke_bnq13k_k$(tmp_20, attendanceGrid$lambda_5(state));
    element_15.onStartup_vrxh3i_k$();
    element_13.addChild_2qpft2_k$(element_15);
    element_13.onStartup_vrxh3i_k$();
    this_25.addChild_2qpft2_k$(element_13);
  }
  element_12.onStartup_vrxh3i_k$();
  this_24.addChild_2qpft2_k$(element_12);
}
function cell(_this__u8e3s4, placement, day, closures, programs, placementAttendances, period) {
  _init_properties_attendanceGrid_kt__smmydr();
  var expected = remember(VOID, VOID, VOID, VOID, ($this$remember) => expectedFor($this$remember.invoke_r7m7el_k$(placement), $this$remember.invoke_r7m7el_k$(day), $this$remember.invoke_r7m7el_k$(closures), $this$remember.invoke_r7m7el_k$(programs)));
  var attendance = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp0 = $this$remember.invoke_r7m7el_k$(placementAttendances);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (element.date_1.equals($this$remember.invoke_r7m7el_k$(day))) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  });
  var state = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(attendance);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.attendance_1;
    var case_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.case_1;
    return !(case_0 == null) ? Companion_instance.of_fosl41_k$(case_0) : !$this$remember.invoke_r7m7el_k$(placement).activeRange_1.contains_pio7lx_k$($this$remember.invoke_r7m7el_k$(day)) ? AttendanceCellState_NotPlaced_getInstance() : $this$remember.invoke_r7m7el_k$(expected) == null ? AttendanceCellState_NotScheduled_getInstance() : !(ensureNotNull($this$remember.invoke_r7m7el_k$(expected)).closure_1 == null) ? AttendanceCellState_Closure_getInstance() : AttendanceCellState_NeedsEntry_getInstance();
  });
  var hasTransport = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(expected);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scheduled_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = tmp1_safe_receiver.transportTo_1 || tmp1_safe_receiver.transportFrom_1;
    }
    return tmp === true;
  });
  var transportTo = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
    var tmp0_safe_receiver = $this$mutableRemember.invoke_r7m7el_k$(attendance);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.attendance_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.transportTo_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp3_safe_receiver = $this$mutableRemember.invoke_r7m7el_k$(expected);
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.scheduled_1;
      tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.transportTo_1;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var tmp5_elvis_lhs = tmp;
    return tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
  });
  var transportFrom = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
    var tmp0_safe_receiver = $this$mutableRemember.invoke_r7m7el_k$(attendance);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.attendance_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.transportFrom_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp3_safe_receiver = $this$mutableRemember.invoke_r7m7el_k$(expected);
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.scheduled_1;
      tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.transportFrom_1;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var tmp5_elvis_lhs = tmp;
    return tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
  });
  var choices = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$(expected);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      return emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var e = tmp;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = e.get_options_jecmyz_k$();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var intermittent = !(e.scheduled_1.timeWhenIntermittent_1 == null) && element.before_1 == null;
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (intermittent) {
        tmp_0 = true;
      } else {
        tmp_0 = null;
      }
      var tmp$ret$8 = tmp_0;
      // Inline function 'kotlin.collections.map' call
      var this_0 = listOfNotNull([false, tmp$ret$8]);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var item = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp$ret$12 = ActualAttendance().new_org_thecommunitygroupinc_cares_ActualAttendance_33pfhi_k$(e.scheduled_1, element, item, $this$remember.invoke_r7m7el_k$(transportTo), $this$remember.invoke_r7m7el_k$(transportFrom));
        destination_0.add_utx5q5_k$(tmp$ret$12);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    return destination;
  });
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    var to = $this$reactive.invoke_r7m7el_k$(transportTo);
    var from = $this$reactive.invoke_r7m7el_k$(transportFrom);
    var tmp0_safe_receiver = $this$reactive.invoke_r7m7el_k$(attendance);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.attendance_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var existing = tmp;
    var tmp_0;
    if (existing.transportTo_1 === to && existing.transportFrom_1 === from) {
      return Unit_instance;
    }
    launch($this$reactive, VOID, VOID, cell$lambda$slambda(existing, to, from, attendance, placement, day));
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  var this_0 = dynamicThemed(_this__u8e3s4, ($this$dynamicThemed) => new (AttendanceEntryBox())($this$dynamicThemed.invoke_r7m7el_k$(state)));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (MenuButton())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = MenuButton$_get_enabled_$ref_o66tn0(element);
  var tmp_1 = getPropertyCallableRef('enabled', 0, tmp, tmp_0, MenuButton$_set_enabled_$ref_647cow(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(day).compareTo_e7gwgq_k$(today()) > 0 ? false : !(period.submitted_1 == null) && !$this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) ? false : $this$invoke.invoke_r7m7el_k$(state).equals(AttendanceCellState_NotPlaced_getInstance()) || $this$invoke.invoke_r7m7el_k$(state).equals(AttendanceCellState_NotScheduled_getInstance()) ? false : $this$invoke.invoke_r7m7el_k$(state).equals(AttendanceCellState_Closure_getInstance()) ? $this$invoke.invoke_r7m7el_k$(choices).get_size_woubt6_k$() > 1 || $this$invoke.invoke_r7m7el_k$(hasTransport) : true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(attendance);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.attendance_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_massachusettsAttendanceCode_3eo4hh_k$();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.get_code_wok7xy_k$();
    var tmp;
    if (tmp3_elvis_lhs == null) {
      var tmp4_safe_receiver = firstOrNull($this$invoke.invoke_r7m7el_k$(choices));
      var tmp_0;
      if (tmp4_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_1;
        if ($this$invoke.invoke_r7m7el_k$(state).equals(AttendanceCellState_Closure_getInstance())) {
          tmp_1 = tmp4_safe_receiver;
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }
      var tmp5_safe_receiver = tmp_0;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.get_massachusettsAttendanceCode_3eo4hh_k$();
      tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.get_code_wok7xy_k$();
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var tmp7_elvis_lhs = tmp;
    return tmp7_elvis_lhs == null ? $this$invoke.invoke_r7m7el_k$(state).mark_1 : tmp7_elvis_lhs;
  });
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  element.requireClick_1 = true;
  element.set_preferredDirection_gql2kx_k$(Companion_getInstance_0().belowRight_1);
  element.opensMenu_gggyad_k$(($this$opensMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = sizeConstraints($this$opensMenu, get_rem_0(20));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = themed(element, LabelGapSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_1.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_2 = get_bold(element_0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_2.willAddChild_hz2iwc_k$(element_1);
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(placement).childName_1);
    element_1.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element_0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
    element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => format($this$invoke.invoke_r7m7el_k$(day), get_menuDateFormat()));
    element_2.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_2);
    element_0.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    element.willAddChild_hz2iwc_k$(element_3);
    element_3.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_3);
    var search = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
    var matchingChoices = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.invoke_r7m7el_k$(choices);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (contains(element.get_massachusettsAttendanceCode_3eo4hh_k$().get_code_wok7xy_k$(), $this$remember.invoke_r7m7el_k$(search), true)) {
          destination.add_utx5q5_k$(element);
        }
      }
      return destination;
    });
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$43 = themed(element, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_3 = get_unpadded(tmp$ret$43);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (RowOrCol())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    this_3.willAddChild_hz2iwc_k$(element_4);
    element_4.set_vertical_nuap32_k$(false);
    element_4.set_gap_jwjroq_k$(get_px(0));
    // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
    var this_4 = get_centered(element_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    var this_5 = themed(this_4, ForcePaddingSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (IconView())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_5.willAddChild_hz2iwc_k$(element_5);
    element_5.set_source_3o5lkf_k$(Companion_getInstance().search_1);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = IconView$_get_description_$ref_x7iif6(element_5);
    var tmp_7 = getPropertyCallableRef('description', 0, tmp_5, tmp_6, IconView$_set_description_$ref_rpvc1e(element_5));
    element_5.invoke_bnq13k_k$(tmp_7, cell$lambda$lambda);
    element_5.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
    var this_6 = weight(element_4, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
    var this_7 = themed(this_6, ForcePaddingSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (TextInput())(this_7.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_7.willAddChild_hz2iwc_k$(element_6);
    element_6.requestFocus_9180nb_k$();
    element_6.bind_gesskf_k$(element_6.content_1, search);
    element_6.set_action_2ds022_k$(Action('Select', VOID, VOID, VOID, VOID, VOID, cell$lambda$slambda_0(matchingChoices, element_6, attendance, placement, day)));
    element_6.onStartup_vrxh3i_k$();
    this_7.addChild_2qpft2_k$(element_6);
    element_4.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_4);
    var tmp_8 = get_scrolling(themed(sizeConstraints(element, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(15)), ListSemantic_getInstance()));
    colOf(tmp_8, matchingChoices, VOID, VOID, VOID, ($this$colOf, choice) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_0 = dynamicThemed($this$colOf, ($this$dynamicThemed) => {
        var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(attendance);
        var current = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.attendance_1;
        var tmp;
        var tmp_0;
        if (equals(current == null ? null : current.case_1, $this$dynamicThemed.invoke_r7m7el_k$(choice).case_1)) {
          tmp_0 = current.useIntermittent_1 === $this$dynamicThemed.invoke_r7m7el_k$(choice).useIntermittent_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = SelectedSemantic_getInstance();
        } else {
          tmp = None_instance;
        }
        return tmp;
      });
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (Button())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(choice).get_massachusettsAttendanceCode_3eo4hh_k$().get_displayName_sscnb0_k$());
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      onClick(element, VOID, VOID, VOID, cell$lambda$lambda$slambda(choice, element, attendance, placement, day));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_8 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(hasTransport));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (RowOrCol())(this_8.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    this_8.willAddChild_hz2iwc_k$(element_7);
    element_7.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (Separator())(element_7.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    element_7.willAddChild_hz2iwc_k$(element_8);
    element_8.onStartup_vrxh3i_k$();
    element_7.addChild_2qpft2_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (TextView())(element_7.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    element_7.willAddChild_hz2iwc_k$(element_9);
    element_9.set_themeChoice_py59um_k$(element_9.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_9 = KMutableProperty0();
    var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_9);
    var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_9));
    element_9.invoke_bnq13k_k$(tmp_11, cell$lambda$lambda_0);
    element_9.onStartup_vrxh3i_k$();
    element_7.addChild_2qpft2_k$(element_9);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_10 = new (RowOrCol())(element_7.get_context_h02k06_k$());
    ensureOutermostElement(element_10);
    element_7.willAddChild_hz2iwc_k$(element_10);
    element_10.set_vertical_nuap32_k$(false);
    var tmp_12 = shownWhen(element_10, VOID, VOID, ($this$shownWhen) => {
      var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(expected);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scheduled_1;
      return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.transportTo_1) === true;
    });
    labeledCheckbox(tmp_12, cell$lambda$lambda_1, transportTo);
    var tmp_13 = shownWhen(element_10, VOID, VOID, ($this$shownWhen) => {
      var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(expected);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scheduled_1;
      return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.transportFrom_1) === true;
    });
    labeledCheckbox(tmp_13, cell$lambda$lambda_2, transportFrom);
    element_10.onStartup_vrxh3i_k$();
    element_7.addChild_2qpft2_k$(element_10);
    element_7.onStartup_vrxh3i_k$();
    this_8.addChild_2qpft2_k$(element_7);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function expectedFor(placement, day, closures, programs) {
  _init_properties_attendanceGrid_kt__smmydr();
  var tmp = Companion_getInstance_1();
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = closures.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.date_1.equals(day)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.reason_1;
  return tmp.of_tn5enx_k$(placement, day, tmp_0, getValue$ref(programs));
}
function attendanceOn(_this__u8e3s4, day, value) {
  _init_properties_attendanceGrid_kt__smmydr();
  return new (ChildAttendance())(VOID, _this__u8e3s4._id_1, _this__u8e3s4.child_1, _this__u8e3s4.family_1, _this__u8e3s4.employers_1, _this__u8e3s4.grants_1, _this__u8e3s4.location_1, _this__u8e3s4.provider_1, day, value);
}
function weekdayFormat$lambda($this$Format) {
  _init_properties_attendanceGrid_kt__smmydr();
  $this$Format.dayOfWeek_tn8lxa_k$(Companion_getInstance_3().ENGLISH_ABBREVIATED_1);
  return Unit_instance;
}
function menuDateFormat$lambda($this$Format) {
  _init_properties_attendanceGrid_kt__smmydr();
  $this$Format.dayOfWeek_tn8lxa_k$(Companion_getInstance_3().ENGLISH_ABBREVIATED_1);
  $this$Format.chars_pe6iqb_k$(', ');
  $this$Format.monthName_asbkgr_k$(Companion_getInstance_4().ENGLISH_ABBREVIATED_1);
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.day_pu15qg_k$(Padding_NONE_getInstance());
  return Unit_instance;
}
function attendanceGrid$lambda($this$remember) {
  _init_properties_attendanceGrid_kt__smmydr();
  return nowLocal().get_date_wokkxj_k$();
}
function attendanceGrid$lambda$lambda(it) {
  _init_properties_attendanceGrid_kt__smmydr();
  return it.childName_1;
}
function attendanceGrid$lambda$lambda_0(it) {
  _init_properties_attendanceGrid_kt__smmydr();
  return it.activeRange_1.start_1;
}
function attendanceGrid$lambda$lambda_1(it) {
  _init_properties_attendanceGrid_kt__smmydr();
  return plus_0(it, 1, Companion_getInstance_5().DAY_1);
}
function attendanceGrid$lambda_0($this$invoke) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_submitAttendance_kcxskq_k$();
}
function attendanceGrid$slambda$lambda($this$confirmationDialog) {
  _init_properties_attendanceGrid_kt__smmydr();
  text($this$confirmationDialog, "This locks the period from further edits. If a correction is needed after this, you'll need to ask TCG to reopen it.");
  return Unit_instance;
}
function attendanceGrid$slambda$slambda($period) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var tmp = session.get_locationAttendancePeriods_kbvlcb_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $period;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var tmp_0 = tmp.get_6ueaa7_k$(new (ID_0())(tmp$ret$1._id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
    var tmp$ret$6 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$6);
    this_2.assign_vtsfu6_k$(get_submitted(it), new (RecordedAction())(session.userId_1));
    var tmp$ret$2 = this_2.build_1k0s4u_k$();
    yield* tmp_0.modify_ff53f_k$(tmp$ret$2, $completion);
    return Unit_instance;
  }), 0);
}
function attendanceGrid$slambda($$this$button, $period) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp0_$receiver = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_strings(AppState_getInstance());
    var tmp1_header = (yield* await_1(this_0, $completion)).get_submitAttendance_kcxskq_k$();
    var tmp = attendanceGrid$slambda$lambda;
    confirmationDialog(tmp0_$receiver, tmp1_header, tmp, 'Submit', VOID, VOID, VOID, attendanceGrid$slambda$slambda($period));
    return Unit_instance;
  }), 1);
}
function attendanceGrid$lambda_1($this$shownWhen) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function attendanceGrid$slambda_0($period) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var tmp = session.get_locationAttendancePeriods_kbvlcb_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $period;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var tmp_0 = tmp.get_6ueaa7_k$(new (ID_0())(tmp$ret$1._id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
    var tmp$ret$6 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$6);
    this_2.assign_vtsfu6_k$(get_approved(it), new (RecordedAction())(session.userId_1));
    var tmp$ret$2 = this_2.build_1k0s4u_k$();
    yield* tmp_0.modify_ff53f_k$(tmp$ret$2, $completion);
    return Unit_instance;
  }), 1);
}
function attendanceGrid$lambda_2($this$invoke) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceNotBegunMessage_a7k34b_k$();
}
function attendanceGrid$lambda_3($this$tableWithSticky, it) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$tableWithSticky;
}
function attendanceGrid$lambda_4($this$TableColumn) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$TableColumn.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceChildScheduleColumnLabel_gdvgn7_k$();
}
function attendanceGrid$lambda$lambda$lambda(it) {
  _init_properties_attendanceGrid_kt__smmydr();
  return it.name_1;
}
function attendanceGrid$lambda$lambda_2($this$TableColumn) {
  _init_properties_attendanceGrid_kt__smmydr();
  return '';
}
function attendanceGrid$lambda$lambda$slambda($this_remember, $placement, $days, $today, $closures, $programs, $allAttendances, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var placement = $this_remember.invoke_r7m7el_k$($placement);
    // Inline function 'kotlin.collections.mutableListOf' call
    var toAdd = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = $this_remember.invoke_r7m7el_k$($days).iterator_jk1svi_k$();
    $l$loop_1: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var day = _iterator__ex2g4s.next_20eer_k$();
      if (day.compareTo_e7gwgq_k$($this_remember.invoke_r7m7el_k$($today)) > 0)
        continue $l$loop_1;
      var tmp0_elvis_lhs = expectedFor(placement, day, $this_remember.invoke_r7m7el_k$($closures), $this_remember.invoke_r7m7el_k$($programs));
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var expected = tmp;
      var tmp0 = $this_remember.invoke_r7m7el_k$($allAttendances);
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.isEmpty_y1axqb_k$();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          if (equals(element.placement_1, placement._id_1) && element.date_1.equals(day)) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
        }
        tmp$ret$1 = false;
      }
      var alreadyRecorded = tmp$ret$1;
      if (alreadyRecorded)
        continue $l$loop_1;
      var value = ActualAttendance().new_org_thecommunitygroupinc_cares_ActualAttendance_uhejyj_k$(expected, expected.get_asScheduledCase_p11tha_k$());
      toAdd.add_utx5q5_k$(attendanceOn(placement, day, value));
    }
    yield* $this_remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenAttendance_3o0zzj_k$().addAll_zaft0n_k$(toAdd, $completion);
    toast($$this$button.get_context_h02k06_k$(), $this_remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceFilledToast_roztnx_k$());
    return Unit_instance;
  }), 1);
}
function attendanceGrid$lambda$lambda_3($it) {
  return ($this$TableColumn) => format($it, get_weekdayFormat()) + ' ' + $it.day_1;
}
function attendanceGrid$lambda$lambda_4($it, $closures, $programs, $this_remember, $period, $allAttendances) {
  return ($this$TableColumn, placement) => {
    var tmp = _Constant___init__impl__v45mub($it);
    cell($this$TableColumn, placement, new (Constant())(tmp), $closures, $programs, remember(VOID, VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.invoke_r7m7el_k$($allAttendances);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (equals(element.placement_1, $this$remember.invoke_r7m7el_k$(placement)._id_1)) {
          destination.add_utx5q5_k$(element);
        }
      }
      return destination;
    }), $this_remember.invoke_r7m7el_k$($period));
    return Unit_instance;
  };
}
function attendanceGrid$lambda_5($state) {
  return ($this$invoke) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return $state.explanation_1($this$invoke);
  };
}
function *cell$record(attendance, $placement, $day, value, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var existing = yield* await_0(attendance, $completion);
  if (!(existing == null)) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_childrenAttendance_3o0zzj_k$().get_6ueaa7_k$(new (ID_1())(existing._id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(ChildAttendance()), arrayOf([]), false));
    var tmp$ret$6 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$6);
    this_1.assign_vtsfu6_k$(get_attendance(it), value);
    var tmp$ret$2 = this_1.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$2, $completion);
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var tmp_1 = (yield* await_0(this_2, $completion)).get_childrenAttendance_3o0zzj_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var tmp_2 = yield* await_0($placement, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var tmp$ret$10 = yield* await_0($day, $completion);
    yield* tmp_1.add_co22jy_k$(attendanceOn(tmp_2, tmp$ret$10, value), $completion);
  }
  return Unit_instance;
}
function cell$lambda$slambda($existing, $to, $from, $attendance, $placement, $day) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/cell$record($attendance, $placement, $day, $existing.copy$default_hj90z6_k$(VOID, VOID, VOID, $to, $from), $completion);
    return Unit_instance;
  }), 1);
}
function MenuButton$_get_enabled_$ref_o66tn0(p0) {
  return constructCallableReference(() => p0.get_enabled_pcr8o8_k$(), 0, 0, 194, VOID, [p0]);
}
function MenuButton$_set_enabled_$ref_647cow(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_enabled_tswf75_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 195, VOID, [p0]);
}
function cell$lambda$lambda($this$invoke) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_searchIconDescription_c0d0b6_k$();
}
function cell$lambda$slambda_0($matchingChoices, $$this$textInput, $attendance, $placement, $day) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $matchingChoices;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    var tmp0_elvis_lhs = firstOrNull(tmp$ret$0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var choice = tmp;
    yield* /*#__NOINLINE__*/cell$record($attendance, $placement, $day, choice, $completion);
    closePopovers($$this$textInput.get_context_h02k06_k$());
    return Unit_instance;
  }), 1);
}
function cell$lambda$lambda$slambda($choice, $$this$button, $attendance, $placement, $day) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $choice;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* /*#__NOINLINE__*/cell$record($attendance, $placement, $day, tmp$ret$0, $completion);
    closePopovers($$this$button.get_context_h02k06_k$());
    return Unit_instance;
  }), 0);
}
function cell$lambda$lambda_0($this$invoke) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceTransportProvidedLabel_ghqywq_k$();
}
function cell$lambda$lambda_1($this$labeledCheckbox) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceTransportToCareLabel_ssvsgh_k$();
}
function cell$lambda$lambda_2($this$labeledCheckbox) {
  _init_properties_attendanceGrid_kt__smmydr();
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceTransportFromCareLabel_elz7b2_k$();
}
function getValue$ref(p0) {
  return constructCallableReference((p0_0) => {
    var tmp0 = p0;
    return getValue(tmp0, p0_0);
  }, 1, 0, 196, 'getValue', [p0]);
}
var properties_initialized_attendanceGrid_kt_7acvov;
function _init_properties_attendanceGrid_kt__smmydr() {
  if (!properties_initialized_attendanceGrid_kt_7acvov) {
    properties_initialized_attendanceGrid_kt_7acvov = true;
    headerHeight = get_rem_0(4);
    rowHeight = get_rem(6.5);
    dayColumnWidth = get_rem(2.3);
    var tmp = Companion_getInstance_2();
    weekdayFormat = tmp.Format_rqffoz_k$(weekdayFormat$lambda);
    var tmp_0 = Companion_getInstance_2();
    menuDateFormat = tmp_0.Format_rqffoz_k$(menuDateFormat$lambda);
  }
}
//region block: exports
export {
  MenuButton$_get_enabled_$ref_o66tn0 as MenuButton$_get_enabled_$ref_o66tn02bouexjmaklml,
  MenuButton$_set_enabled_$ref_647cow as MenuButton$_set_enabled_$ref_647cow1po0j8ztqws82,
  getValue$ref as getValue$ref3cl0ea1sg24pj,
  attendanceGrid as attendanceGrida6fmjgaehija,
};
//endregion

//# sourceMappingURL=attendanceGrid.mjs.map
